import { Environment, EnvironmentName } from "../models/environment";
import { Dev, Stage, Prod, Local } from "./";

function getHostMapping(): string {
    const host = window.location.host;
    const host_Mapping = {
        "ACO": ["onecare-stage.avaya.com", "cms.avaya.com", "onecare.avaya.com", "localhost:3001"],
        "GSS": ["support-dev.avaya.com","supportbetasite-stg.avaya.com", "support.avaya.com", "localhost:3000"],
    }
    for (const [key, mappings] of Object.entries(host_Mapping)) {
        if (mappings.includes(host)) {
            console.log('Environment:', key);
            return key;
        }
    }
    return '';
}

const app = getHostMapping();

function getEnvsByName(name:string,app:string): Environment[] {
    let envs:Environment[] = [];
    switch (name) {
        case 'DEV':
            envs = Dev[app];
            break
        case'STAGE':
            envs = Stage[app];
            break
        case 'PROD':
            envs = Prod[app];
            break
        default:
            envs = Local[app];
    }
    return envs

}


// export const ENV = filterEnvsByMandatoryProperties(getEnvsByName(process.env.REACT_APP_ENVIRONMENT || 'local', app)) || getDefaultEnvironment();

export function GetEnvironments(): Environment[]{
    return getEnvsByName(process.env.REACT_APP_ENVIRONMENT || 'local', app) || getDefaultEnvironments()
}

export function getDefaultEnvironments(): Environment[] {
  return [{
    env: EnvironmentName.local,
    bot: { name: "default_bot" },
    protocol: "https",
    visible: false,
    url: {
      axp: { host: "localhost", entrypoint: "/axp" },
      api: { host: "localhost", entrypoint: "/api" },
      static: { host: "localhost", entrypoint: "/static" },
    },
    default_queue: "default_queue",
    mandatory_properties: {
    },
    auth: {
      local_storage_var_name: "auth_user_token",
      access_token_path: "response.data.access_token",
      company_id_path: "response.data.company_id",
      email_id_path: "response.data.email_id",
      first_name_path: "response.data.first_name",
      last_name_path: "response.data.last_name",
      phone_number_path: "response.data.phone_number",
      user_role_path: "response.data.user_role",
      user_type_path: "response.data.user_type",
      user_id_path: "response.data.user_id",
    },
    allowed_paths:[],
    envEndpoint: {
        api: {
            backend: '/backendavayacc',
            firestore: '/firestoreData',
            saveTranscript: '/eptcct-axp-getEngagement/api/saveTranscript',
            engagementLanguage: '/eptcct-axp-getEngagement/api/getEngagement'
        },
        static: {
            media: '/static/media',
        }
    }
  }];
}



